export const primaryRoles = {
  global: "global",
  regional: "regional"
}
